import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardPayrollService from "./dashboardPayrollService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
  getFormatOraInput,getFormatOraInputFirst,getFormatOraInputEnd,getFormatForFile
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import { validEmail, validPassword } from "../../../common/utils";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
// import user from '../../../mokup_ListaUser'

toast.configure();

class dashboardPayroll extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectControllore: [],
      numeroControllore: "",
      dataInizio: "",
      dataFine: "",
      data: [],
      showModalSanzioniRecidivo: false,
      dataTableSanzione: [],
      dataTableSanzioneCSV: [],
      csvFile: [],
      headerDataTableSanzione: [],
      searchNumSanzione: "",
      searchDataEmissione: "",
      searchNome: "",
      searchCognome: "",
      searchCF: "",
      loading: true,
      showModalModificaUser: false,
      selectRoleOption: false,
      isErrornumMatricola: false,
      isErrorPassword: false,
      isErrorEmail: false,
      isErrorNome: false,
      isErrorCognome: false,
      isErrorRuolo: false,
      recidivi: [
        {
          nome: "",
          cognome: "",
          cf: "",
          nSanz: 0,
          listaDiDettaglioSanzioni: [
            {
              numSanzione: "",
              dataEmissione: 0,
              statoSanzione: "",
              idSanzione: 0,
            },
          ],
        },
      ],
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    const emailRegex = /^\S+@\S+\.\S+$/;
  }

  componentDidMount() {
    // sessionStorage.removeItem("ListaSaznioniRecidivo");
    this.dashboardSanzioneService = new DashboardPayrollService();
    this.dashboardSanzioneService.getDataCotrollori((result) => {
      this.state.selectControllore = result;
      this.setState({
        state: this.state.selectControllore,
      });
    });
    var moment = require("moment");
    var numControllore = sessionStorage.getItem("numeroControllorePayroll");
    var dataInizio = sessionStorage.getItem("dataInizioPayroll");
    var dataFine = sessionStorage.getItem("dataFinePayroll");
    this.state.numeroControllore = numControllore;
    if (dataInizio) {
      this.state.dataInizio = parseInt(dataInizio);
    }else{
      var d = new Date();
      d.setMonth(d.getMonth(), -1);
      this.state.dataInizio = getFormatOraInputFirst(d);
    }
    if (dataFine) {
      this.state.dataFine = parseInt(dataFine);
    }else{
      var d = new Date();
      d.setMonth(d.getMonth(), -1);
      this.state.dataFine = getFormatOraInputEnd(d);

    }
    this.setState({
      state: this.state.numeroControllore,
    });
    this.setState({
      state: this.state.dataInizio,
    });
    this.setState({
      state: this.state.dataFine,
    });
    // console.log(getFormatOraInput(parseInt(this.state.dataInizio)));
    // if (numControllore != "") {
      if(this.state.numeroControllore && this.state.dataInizio && this.state.dataFine){
        this.getDataTable(
          this.state.numeroControllore,
          this.state.dataInizio,
          this.state.dataFine
        );
      }
    // }

    // sessionStorage.removeItem("numeroControllorePayroll");
    //                       sessionStorage.setItem("numeroControllorePayroll", this.state.numeroControllore);
    //                       sessionStorage.removeItem("dataInizioPayroll");
    //                       sessionStorage.setItem("dataInizioPayroll",this.state.dataInizio);
    //                       sessionStorage.removeItem("dataFinePayroll");
    //                       sessionStorage.setItem("dataFinePayroll",this.state.dataFine);

    this.state.loading = false;
  }

  getDataTable(nomeControllore, dataInizio, dataFine) {
    this.dashboardSanzioneService.getDatiConrollore(
      nomeControllore,
      dataInizio,
      dataFine,
      this.onSuccessLoadDataTableSanzione.bind(this)
    );
  }
  onSuccessLoadDataCharter(result) {
    this.setState((this.data = result));
  }
  onSuccessLoadDataTableSanzione(resultHeader, resultBody, resultttt) {
    var sanzioni = resultBody;
    var moment = require("moment");
    var numSanzioniInscadenza = 0;
    for (let i = 0; i < sanzioni.length; i++) {
      var sanzione = sanzioni[i];
      var allaScadenza = "-";
      if ("Caricato" === sanzioni[i].statoSanzione) {
        var diff = calculateTimeDifferenceTwoDates(
          new Date(),
          moment(sanzione.dataEmissione, "DD/MM/YYYY").toDate()
        );
        allaScadenza = 60 - parseInt(diff, 10);
        var val = "-";
        if (allaScadenza < 0) {
          val = "Scaduto";
          numSanzioniInscadenza += 1;
        } else {
          val = "Scade tra " + allaScadenza + " giorni";
          if (allaScadenza < 5) numSanzioniInscadenza += 1;
        }
        sanzione.giorniAllaScadenza = val;
      } else {
        // sanzione.giorniAllaScadenza = " - ";
      }
    }

    // var mexError =
    //   "Attenzione " + numSanzioniInscadenza + " sanzioni in scadenza!";
    // if (numSanzioniInscadenza > 5)
    //   toast.warn(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else if (numSanzioniInscadenza > 10)
    //   toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else toast.info(numSanzioniInscadenza + " sanzioni in scadenza ");
    resultBody.map((val) => {
      val.stato !== 0
        ? (val.stato = <i style={{ color: "green" }} class="fas fa-check"></i>)
        : (val.stato = <i style={{ color: "red" }} class="fas fa-times"></i>);
    });
    this.setState((this.headerDataTableSanzione = resultHeader));
    this.setState({ dataTableSanzioneCSV: resultBody });
    this.setState({ dataTableSanzione: resultBody });
    this.setState({csvFile:[]});
    this.setState({ loading: false });
    // console.log(result);
    resultttt.map((dati) => {
      if (dati.stato === 0) {
      } else {
        this.state.csvFile = [
          ...this.state.csvFile,
          {
            // stato: dati.stato,
            numSanzione: dati.numSanzione,
            importo:
              parseFloat(dati.importo / 100)
                .toFixed(2)
                .toString()
                .replace(".", ",") + " €",
            dataPayroll: geDataFormat(dati.dataPayroll),
          },
        ];
        // delete dati.clickEvent;
      }
    });
    this.setState({ state: this.state.csvFile });
    // this.setState({ csvFile: this.state.csvFile });
  }

  onRowClick(row) {
    var righa = {
      id: row.idSanzione,
      payroll: true,
    };
    sessionStorage.removeItem("rowSanzione");
    sessionStorage.setItem("rowSanzione", JSON.stringify(righa));
    this.props.history.push("/detailSanzione");

    // console.log(row);
    // console.log(row);//dati della righa da passare
    // this.props.history.push("/detailProfile");
    // console.log(JSON.stringify(row))
    // this.setState({ showModalSanzioniRecidivo: true });
  }

  // chiudiScheda() {
  //   sessionStorage.removeItem("ListaSaznioniRecidivo");
  //   this.setState({ showModalSanzioniRecidivo: false });
  // }

  onChangeNumeromatricola(event) {
    this.state.numeroControllore = event.target.value;
    // console.log(event.target.value);
    this.setState({
      state: this.state.numeroControllore,
    });
  }
  onChangeDataInizio(event) {
    this.state.dataInizio = event.target.value;
    // console.log(event.target.value);
    this.setState({
      state: this.state.dataInizio,
    });
  }

  onChangeDataFine(event) {
    this.state.dataFine = event.target.value;
    // console.log(event.target.value);
    this.setState({
      state: this.state.dataFine,
    });
  }

  dataObj() {
    for (const item of this.state.dataTableSanzione) {
      item.clickEvent = () => this.onRowClick(item);
    }
    var data = {
      columns: this.headerDataTableSanzione,
      rows: this.state.dataTableSanzione,
    };
    return data;
  }

  renderTableData() {
    if (
      this.state.dataTableSanzione &&
      this.state.dataTableSanzione.length > 0
    ) {
      return (
        <CDBContainer>
          <CDBCard border>
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="col">Matricola: </div>
                  <div className="col">
                    <select
                      className="form-control"
                      onChange={this.onChangeNumeromatricola.bind(this)}
                    >
                      {this.state.selectControllore.map((val, index) => {
                        return (
                          <>
                            {" "}
                            {index === 0 ? (
                              <option
                                selected
                                value={0}
                                placeholder="Seleziona"
                              >
                                {"Seleziona"}
                              </option>
                            ) : (
                              ""
                            )}
                            <option
                              value={val.numMatricola}
                              selected={
                                this.state.numeroControllore ===
                                val.numMatricola
                              }
                            >
                              {val.numMatricola}
                            </option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="col">Data Inizio: </div>
                  <div className="col">
                    <input
                      value={getFormatOraInput(this.state.dataInizio)}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataInizio.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="col">Data Fine: </div>
                  <div className="col">
                    <input
                      value={getFormatOraInput(this.state.dataFine)}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataFine.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  {/* <div className="col">Filtri: </div> */}
                  <br></br>
                  <div className="col">
                    <button
                      className="btn btn-warning"
                      style={{ width: "100%" }}
                      onClick={() => {
                        const dataOreInizio = new Date().setDate(
                          new Date().getDate() - 30
                        );
                        const dataOraCorrettaInizio = new Date(
                          dataOreInizio
                        ).setHours(0, 0, 0);

                        this.state.dataInizio === ""
                          ? (this.state.dataInizio = dataOraCorrettaInizio)
                          : (this.state.dataInizio = +new Date(
                              this.state.dataInizio
                            ).setHours(0, 0, 0));
                        this.state.dataFine === ""
                          ? (this.state.dataFine = +new Date().setHours(
                              23,
                              59,
                              59
                            ))
                          : (this.state.dataFine = +new Date(
                              this.state.dataFine
                            ).setHours(23, 59, 59));

                        sessionStorage.removeItem("numeroControllorePayroll");
                        sessionStorage.setItem(
                          "numeroControllorePayroll",
                          this.state.numeroControllore
                        );
                        sessionStorage.removeItem("dataInizioPayroll");
                        sessionStorage.setItem(
                          "dataInizioPayroll",
                          this.state.dataInizio
                        );
                        sessionStorage.removeItem("dataFinePayroll");
                        sessionStorage.setItem(
                          "dataFinePayroll",
                          this.state.dataFine
                        );

                        this.getDataTable(
                          this.state.numeroControllore,
                          this.state.dataInizio,
                          this.state.dataFine,
                          (head, reult) => {
                            // console.log(reult);
                          }
                        );
                      }}
                    >
                      Applica Filtri
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CDBCardBody>
              <CDBDataTable
                sortable={false}
                responsiveSm={true}
                responsiveMd={true}
                responsiveLg={true}
                pagesAmount={3}
                entriesLabel={""}
                entries={20}
                // tbodyColor="table-warning"
                // className="table-primary"
                infoLabel={["Mostra da", "a", "di", "payroll totali"]}
                paginationLabel={["<-", "->"]}
                striped
                bordered
                hover
                checkbox
                data={this.dataObj()}
                materialSearch
              />
            </CDBCardBody>
          </CDBCard>
        </CDBContainer>
      );
    } else {
      return (
        <>
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="col">Matricola: </div>
                <div className="col">
                  <select
                    className="form-control"
                    onChange={this.onChangeNumeromatricola.bind(this)}
                  >
                    {this.state.selectControllore.map((val, index) => {
                      return (
                        <>
                          {" "}
                          {index === 0 ? (
                            <option selected value={0} placeholder="Seleziona">
                              {"Seleziona"}
                            </option>
                          ) : (
                            ""
                          )}
                          <option value={val.numMatricola}>
                            {val.numMatricola}
                          </option>
                        </>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col">
                <div className="col">Data Inizio: </div>
                <div className="col">
                  <input
                    value={getFormatOraInput(this.state.dataInizio)}
                    type="date"
                    className="form-control"
                    onChange={this.onChangeDataInizio.bind(this)}
                  />
                </div>
              </div>
              <div className="col">
                <div className="col">Data Fine: </div>
                <div className="col">
                  <input
                    value={getFormatOraInput(this.state.dataFine)}
                    type="date"
                    className="form-control"
                    onChange={this.onChangeDataFine.bind(this)}
                  />
                </div>
              </div>
              <div className="col">
                <br></br>
                <div className="col">
                  <button
                    className="btn btn-warning"
                    style={{ width: "100%" }}
                    onClick={() => {
                      // console.log(this.state.numeroControllore);
                      // console.log(this.state.dataInizio);
                      // console.log(this.state.dataFine);

                      const dataOreInizio = new Date().setDate(
                        new Date().getDate() - 30
                      );
                      const dataOraCorrettaInizio = new Date(
                        dataOreInizio
                      ).setHours(0, 0, 0);

                      this.state.dataInizio === ""
                        ? (this.state.dataInizio = dataOraCorrettaInizio)
                        : (this.state.dataInizio = +new Date(
                            this.state.dataInizio
                          ).setHours(0, 0, 0));
                      this.state.dataFine === ""
                        ? (this.state.dataFine = +new Date().setHours(
                            23,
                            59,
                            59
                          ))
                        : (this.state.dataFine = +new Date(
                            this.state.dataFine
                          ).setHours(23, 59, 59));

                      sessionStorage.removeItem("numeroControllorePayroll");
                      sessionStorage.setItem(
                        "numeroControllorePayroll",
                        this.state.numeroControllore
                      );
                      sessionStorage.removeItem("dataInizioPayroll");
                      sessionStorage.setItem(
                        "dataInizioPayroll",
                        this.state.dataInizio
                      );
                      sessionStorage.removeItem("dataFinePayroll");
                      sessionStorage.setItem(
                        "dataFinePayroll",
                        this.state.dataFine
                      );

                      this.getDataTable(
                        this.state.numeroControllore,
                        this.state.dataInizio,
                        this.state.dataFine,
                        (head, reult) => {
                          console.log(reult);
                        }
                      );
                      // var search = this.props.location.search;
                      // var stato = "daLav";
                      // if (search != null && search.includes("?")) {
                      //   stato = search.substring(1, search.lenght);
                      // }
                      // this.getDataTable(
                      //   stato,
                      //   this.state.filtro.dataInizio,
                      //   this.state.filtro.dataFine
                      // );
                    }}
                  >
                    Applica Filtri
                  </button>
                </div>
              </div>
            </div>
          </div>
          <br></br>
          <br></br>
          <br></br>
          <div className="text-center">
            <h1>Nessun dato, effettua una ricerca.</h1>
          </div>
        </>
      );
    }
  }

  render() {
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Payroll<br></br>
              <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              >
                Payroll
              </small>
            </h1>
            {this.state.csvFile.length > 0 ? (<CSVLink
              data={this.state.csvFile}
              separator={";"}
              filename={`Payroll_${this.state.numeroControllore}_${getFormatForFile(this.state.dataInizio)}_${getFormatForFile(this.state.dataFine)}.csv`}
            >
              <button disabled={this.state.csvFile.length > 0 ? false : true} type="button" class="btn btn-warning">
                {" "}
                <i className="fas fa-download fa-sm text-white"></i>{" "}
                &nbsp;Esporta Dati
              </button>
              </CSVLink>)
            :(<button disabled={this.state.csvFile.length > 0 ? false : true} type="button" class="btn btn-warning">
            {" "}
            <i className="fas fa-download fa-sm text-white"></i>{" "}
            &nbsp;Esporta Dati
          </button>)}
          </div>
          <br />
          <br />
          <div className="col">{this.renderTableData()}</div>
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(dashboardPayroll);
